import productFootBath from './productFootBath/config/routes' //快速开单
import setMeal from './setMeal/config/routes' //套餐开卡、划卡
import member from './member/config/routes' //会员充值、销卡
import paperRepair from './paperRepair/config/routes' //修护开卡
// import reserveInfo from "./reserveInfo/config/routes"; //预约泡脚
import paperCard from './paperCard/config/routes' //纸质划卡
import paperSetMeal from './paperSetMeal/config/routes' //纸质套餐
import paperManage from './paperManage/config/routes' //纸质套餐
import paperTable from './paperTable/config/routes' //纸质修护
import deductTable from './deductTable/config/routes' //提出配置
import icCard from './icCard/config/routes' //ic转卡
import cardRecord from './cardRecord/config/routes' // ic转卡记录
import memberRecharge from './memberRecharge/config/routes' // 会员充值
import memberLogout from './memberLogout/config/routes' // 会员销卡

export default [
	// {
	//       path: '/collectMoney',
	//       component: resolve => require(['./center.vue'], resolve),
	//       meta: {
	//           title: '管理中心',
	//           keepAlive: false
	//       }
	//   },
	...productFootBath,
	...setMeal,
	...member,
	...paperRepair,
	// ...reserveInfo,
	...paperCard,
	...paperSetMeal,
	...paperTable,
	...deductTable,
	...paperManage,
	...icCard,
	...cardRecord,
  ...memberRecharge,
  ...memberLogout
]
